
export const GET_SUBSCRIBE_PRICE_SCREEN_DATA = `GET_SUBSCRIBE_PRICE_SCREEN_DATA`

export const getSubscribePriceScreenData = (payload:any): any => {
	return {
		type: GET_SUBSCRIBE_PRICE_SCREEN_DATA,
		payload
	}
}